"use client";

import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    const fallbackServices = ["Miller Welder Repair", "Lincoln Welder Repair", "Hypertherm Plasma Cutter Repair", "Circuit Board Repair"];
    return <ul className="space-y-3">
        {fallbackServices.map((service, i) => <li key={i} data-index={i}>
            <Link to="/RepairSolutionsPage" className="text-sm text-muted-foreground hover:text-ring transition-colors">
              {service}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-ring transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="bg-background text-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591728/img/olive_hill_equipment_service_logo.png" alt="Olive Hill Equipment Service" className="h-7 w-auto" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Expert repair and maintenance for Miller and Lincoln welders, and
              Hypertherm plasma cutters. Minimizing downtime with reliable,
              certified service.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-base font-semibold tracking-tight">
              Quick Links
            </h3>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-base font-semibold tracking-tight">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 text-ring shrink-0 mt-0.5" />
                <span className="text-sm text-muted-foreground">1940 Semora Rd, Roxboro, NC 27574</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 text-ring shrink-0" />
                <span className="text-sm text-muted-foreground">(336) 828 - 6177</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 text-ring shrink-0" />
                <span className="text-sm text-muted-foreground break-all">support@ohequipservice.com</span>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-base font-semibold tracking-tight">
              Shop Hours
            </h3>
            <div className="bg-muted/30 rounded-lg p-4 border border-border/50">
              <Table className="font-mono text-sm">
                <TableBody>
                  <TableRow className="border-border/50 hover:bg-transparent">
                    <TableCell className="py-2 pl-0 text-muted-foreground">
                      Mon-Fri
                    </TableCell>
                    <TableCell className="py-2 pr-0 text-right text-foreground font-medium">
                      8am - 5pm
                    </TableCell>
                  </TableRow>
                  <TableRow className="border-0 hover:bg-transparent">
                    <TableCell className="py-2 pl-0 text-muted-foreground">
                      Sat-Sun
                    </TableCell>
                    <TableCell className="py-2 pr-0 text-right text-muted-foreground">
                      Closed
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-ring flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground text-center md:text-left">
            © {new Date().getFullYear()} Olive Hill Equipment Service. All rights
            reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="text-sm text-muted-foreground hover:text-ring transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="text-sm text-muted-foreground hover:text-ring transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}